"use client";

import type { ReactElement } from "react";
import { MessengerArticleView } from "./messenger-article-view";
import { MessengerChatView } from "./messenger-chat-view";
import { useMessenger } from "./messenger-context";
import { MessengerHelpSpaceView, MessengerHelpView } from "./messenger-help-view";
import { MessengerHomeView } from "./messenger-home-view";
import { MessengerConversationList } from "./messenger-lists";
import { MessengerTabBar } from "./messenger-tab-bar";
import { MessengerTicketView } from "./messenger-ticket-view";
import { MessengerVisitorChatView } from "./messenger-visitor-chat-view";
import { isTabView } from "./messenger-types";

/** Content of the messenger: the current view, tabs on the root views. */
export function MessengerWindow(): ReactElement {
  const { audience, nav } = useMessenger();
  const view = nav.view;
  const visitor = audience.kind === "visitor";
  return (
    <div className="relative flex min-h-0 flex-1 flex-col bg-background">
      {view.kind === "home" ? <MessengerHomeView /> : null}
      {view.kind === "messages" ? <MessengerConversationList /> : null}
      {view.kind === "help" ? <MessengerHelpView /> : null}
      {view.kind === "chat" && visitor ? <MessengerVisitorChatView key={view.pendingText ?? "visitor"} askText={view.pendingText ?? null} /> : null}
      {view.kind === "chat" && !visitor ? (
        <MessengerChatView key={view.sessionId ?? "new"} sessionId={view.sessionId} pendingText={view.pendingText} />
      ) : null}
      {view.kind === "ticket" ? <MessengerTicketView key={view.taskId} taskId={view.taskId} /> : null}
      {view.kind === "helpSpace" ? <MessengerHelpSpaceView spaceId={view.spaceId} /> : null}
      {view.kind === "article" ? <MessengerArticleView key={view.pageId} pageId={view.pageId} /> : null}
      {isTabView(view) ? <MessengerTabBar active={view.kind} /> : null}
    </div>
  );
}
